import {
  Component,
  Input, OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from './api.service';
import {Four51Service} from './four51.service';
import {CartService} from './cart.service';
import {Subscription} from 'rxjs';
import {Router} from '@angular/router';
import * as moment from 'moment';
import {KnackService} from './knack.service';
import {OrderLimitResponse, OrderLimitService} from './order-limit.service';

@Component({
  selector: 'app-pdf-modal-component',
  template: `
      <div class="modal-header">
          <h4 class="modal-title">Edit {{product.Name}}</h4>
          <div *ngIf="shouldShowFit" class="btn-group ml-auto" role="group" aria-label="Order Types">
              <button type="button" class="btn btn-outline-primary btn-sm" [class.active]="shouldFit"
                      (click)="shouldFit = true">Fit in Window</button>
              <button type="button" class="btn btn-outline-primary btn-sm" [class.active]="!shouldFit"
                      (click)="shouldFit = false">Max Size</button>
          </div>
          <button type="button" ngbAutofocus class="close" [class.ml-0]="shouldShowFit" aria-label="Close" (click)="activeModal.dismiss()">
              <span aria-hidden="true">&times;</span>
          </button>
      </div>
      <div class="modal-body modal-body-proof d-flex no-gutters" *ngIf="product.SpecCount > 0">
          <div class="col-lg-4">
              <app-spec [specs]="variant.Specs" [isEditing]="true"
                        (specsChange)="specsChange($event)"></app-spec>
          </div>
          <div class="col-lg-8">
              <div class="proof-wrapper" *ngIf="imageUrl">
                  <img [src]="imageUrl" [class.fit]="shouldFit" (load)="onPreviewLoaded($event)" (error)="onPreviewError($event)"
                       [alt]="product.Name + 'Preview Image'" />
                  <div class="activity d-flex" *ngIf="isWaiting">
                      <div class="spinner-border text-light m-auto" role="status" >
                          <span class="sr-only">Loading...</span>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="modal-footer">
              <button type="buton" class="btn btn-primary" (click)="activeModal.close()" [disabled]="!isProofed || isUpdating || isWaiting">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isUpdating"></span>
                  Done
              </button>
          <div *ngIf="errorMessage" class="alert alert-danger my-0" [innerHTML]="errorMessage"></div>
      </div>
  `,
  styleUrls: ['./modal.component.scss'],
  styles: [`
    .proof-wrapper {
      height: 100%;
      overflow-y: scroll;
    }
    .activity {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: rgba(0,0,0,0.4);
      z-index: 99;
    }
    .fit {
        max-height: 100%;
        max-width: 100%;
    }`
  ]
})
export class ProductEditModalComponent implements OnInit {

  @Input() product: any;
  @Input() variant: any;
  public isProofed = true;
  private imageUrl;
  private proofUrl;
  public isWaiting: boolean;
  public isUpdating = false;
  public errorMessage: string;
  public shouldFit = false;
  public shouldShowFit = false;

  constructor(public activeModal: NgbActiveModal, private apiService: ApiService) {}

  ngOnInit(): void {
    this.isWaiting = true;
    if (this.isPresignedUrlExpired(this.variant.PreviewUrl)) {
      this.updateVariant()
    } else {
      this.imageUrl = this.variant.PreviewUrl;
    }
  }
  onPreviewLoaded(e) {
    this.isWaiting = false;
    if (e.target.offsetWidth > 960) {
      this.shouldShowFit = true;
    } else {
      this.shouldShowFit = false;
    }
  }

  onPreviewError(e) {
    console.log(e);
    this.isWaiting = false;
    this.errorMessage = 'ATTENTION: We are unable to process this request due to an issue with the photo on file. ' +
      'Please email <a href=mailto:PhysicianPhotos@mdvip.com">PhysicianPhotos@mdvip.com</a> for assistance.';
  }

  specsChange(isFormValid: boolean) {
    this.isProofed = isFormValid;
    this.updateVariant();
  }

  async updateVariant() {
    this.isWaiting = true;
    // const response = await this.four51Service.createVariant(this.variant).toPromise();

    const templateData = {};
    for (var key in this.variant.Specs) {
      if (this.variant.Specs.hasOwnProperty(key)) {
        if (['V10Certifications', 'V11Medical_School', 'V12Hospital_Affiliations'].includes(key)) {
          templateData[key] = this.variant.Specs[key].Value.replace(/\r?\n/g, '<br>')
        } else {
          templateData[key] = this.variant.Specs[key].Value;
        }
      }
    }
    
    const body = {
        templateUrl: this.getTemplateUrl(this.product.InteropID),
        data: templateData,
        scale: 1.0,
        width: 8.5,
        height: 11.0,
        pages: 1
    };

    if (this.product.InteropID === '82E756E2-5D8B-441B-B281-473853AFE714') {
      body.scale = 1.5;
    }
    if (this.product.InteropID === '83D31E03-F16E-4FE2-923A-59FFE07C2A8F') {
      body.width = 11.25;
      body.height = 5.75;
      body.pages = 2;
    }
    if (this.product.InteropID === 'A2C21292-3572-44B7-8CEB-F6929DB254FF') {
      body.width = 8.0625;
      body.height = 9;
    }
    if (this.product.InteropID === '49D4F31D-1A5B-435F-9094-070063F47B26' || 
        this.product.InteropID === 'MD52410' ||
        this.product.InteropID === 'MD64612') {
      body.width = 8.0625;
      body.height = 7;
    }

    const jpegResponse = await this.apiService.getJpeg(body).toPromise();
    this.variant.PreviewUrl = jpegResponse.url;

    const response = await this.apiService.createVariant(this.variant).toPromise();
    this.variant = response;
    this.imageUrl = this.variant.PreviewUrl;
    // this.variant = response.body;
    // this.imageUrl = this.variant.PreviewUrl;
  }

  getTemplateUrl(InteropID: string): string {
    switch (InteropID) {
      case '0DDDF4AD-998C-4567-A56D-5E11EB7909E2':
        // Heart Disease/Stroke Handout
        // MD.51357
        return 'https://mdvipsf.seprint.com/assets/pdf-gen/templates/md-51357.html';
      case '82E756E2-5D8B-441B-B281-473853AFE714':
        // Pre-Wellness Checklist
        // MD.61367
        return 'https://mdvipsf.seprint.com/assets/pdf-gen/templates/md-61367.html';
      case '83D31E03-F16E-4FE2-923A-59FFE07C2A8F':
        // Annual Wellness Reminder Postcard
        // MD.64554
        return 'https://mdvipsf.seprint.com/assets/pdf-gen/templates/md-64554.html';
      case 'E93CACCD-C644-4FE8-AF48-23AA8654E09A':
        // Pre-Wellness Plus Checklist
        // MD.64528
        return 'https://mdvipsf.seprint.com/assets/pdf-gen/templates/md-64528.html';
      case '7921B000-B0AB-4AAE-8B5E-E252292595DD':
        // Women's Health Pre-Wellness Checklist
        // MD.64546
        return 'https://mdvipsf.seprint.com/assets/pdf-gen/templates/md-64546.html';
      case 'MD64612':
        // Women’s Health Program Referral Cards
        // MD.64612
        return 'https://mdvipsf.seprint.com/assets/pdf-gen/templates/md-64612.html';
      case 'A2C21292-3572-44B7-8CEB-F6929DB254FF':
        // Referral Cards With Appointment Card
        // MD.52408
        return 'https://mdvipsf.seprint.com/assets/pdf-gen/templates/md-52408.html';
      case '49D4F31D-1A5B-435F-9094-070063F47B26':
      case 'MD52410':
        // Referral Cards Without Appointment Card
        // MD.52409
        return 'https://mdvipsf.seprint.com/assets/pdf-gen/templates/md-52409.html';
      default:
        return '';
    }
  }

  isPresignedUrlExpired(url: string) {
     if (!url) {
      return true; // If URL is not provided, consider it expired
    }
    const { searchParams } = new URL(url);
    const dateStr = searchParams.get('X-Amz-Date') || searchParams.get('x-amz-date');
    const expiresStr = searchParams.get('X-Amz-Expires') || searchParams.get('x-amz-expires');
    if (!dateStr || !expiresStr) {
      throw new Error('URL is missing X-Amz-Date and/or X-Amz-Expires');
    }

    // Parse YYYYMMDDTHHMMSSZ
    const year   = +dateStr.slice(0, 4);
    const month  = +dateStr.slice(4, 6) - 1;
    const day    = +dateStr.slice(6, 8);
    const hour   = +dateStr.slice(9, 11);
    const minute = +dateStr.slice(11, 13);
    const second = +dateStr.slice(13, 15);
    const signingTime = Date.UTC(year, month, day, hour, minute, second);

    const expiresMs = parseInt(expiresStr, 10) * 1000;
    const expiryTime = signingTime + expiresMs;

    return Date.now() > expiryTime;
  }
}
